// extracted by mini-css-extract-plugin
var _1 = "vXzXbGbv4PjardhNJtaD";
var _2 = "WX5NOIBZ3holIh2hpPBJ";
export { _1 as "bannerImage", _2 as "bannerLink" }
